export const NO_ACCESS = 2
export enum statusEnum{
    '直播未开始' = 0,
    '主播暂时离开或直播已结束' = 1,
    '直播已结束' = 2,
    '直播回放中' = 3,
    '无效直播' = 4,
}
